/* unplugin-vue-components disabled */import script from "./AnalyzeTtgView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyzeTtgView.vue?vue&type=script&setup=true&lang=js"

import "./AnalyzeTtgView.vue?vue&type=style&index=0&id=7344ed22&lang=css"

const __exports__ = script;

export default __exports__